<template>
  <div class="home">
    <innerHeader v-if="!isMobile"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="3"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          :ys="{ width: '100%' }"
        >
          <div slot="main_content">
            <div class="content_top" v-if="videoList.length">
              <div class="video_con">
                <!-- 主图 -->
                <div class="swiper mySwiper2" id="mySwiper2">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      ref="mySwiper2"
                      v-for="(item, index) in videoList"
                      :key="index"
                      @click="playVideo(item, index)"
                    >
                      <img
                        class="video_item_default"
                        v-if="item.coverImg"
                        :src="item.coverImg"
                      />
                      <img
                        class="video_item_default"
                        v-if="!item.coverImg"
                        :src="videoDefault"
                      />
                      <video
                        v-show="false"
                        controls
                        style="width: 999px; height: 562px"
                        :ref="'mainVideo-' + index"
                        @play="pauseOtherVideos(index)"
                      >
                        <source :src="item.videoUrl" type="video/mp4" />
                      </video>
                      <div class="play_con" @click="pauseOtherVideos(index)">
                        <img src="../../assets/img/play_icon.png" />
                      </div>
                    </div>
                  </div>
                  <div
                    class="video-button-prev"
                    v-if="videoList.length > 1"
                  ></div>
                  <div
                    class="video-button-next"
                    v-if="videoList.length > 1"
                  ></div>
                </div>
                <!-- 缩略图 -->
                <div class="swiper mySwiper" id="mySwiper" ref="mySwiper">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide thumb-swiper-slide"
                      v-for="(item, index) in videoList"
                      :key="index"
                    >
                      <img
                        class="video_item_default"
                        v-if="item.coverImg"
                        :src="item.coverImg"
                      />
                      <img
                        class="video_item_default"
                        v-if="!item.coverImg"
                        :src="videoDefault"
                      />
                      <!-- <video
                        style="width: 240px; height: 135px"
                        :ref="'thumbVideo-' + index"
                        controlslist="nodownload nofullscreen noremoteplayback"
                        disablePictureInPicture
                        @click.prevent
                      >
                        <source :src="item.videoUrl" type="video/mp4" />
                      </video> -->
                      <div class="play_con">
                        <img src="../../assets/img/play_icon.png" />
                      </div>
                    </div>
                  </div>
                  <div class="thumb-button-prev"></div>
                  <div class="thumb-button-next"></div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="1"
          :cloumnId="cloumnId"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="video_top" v-if="videoList0.length">
                <div class="content_item_img">
                  <!-- <img v-lazy="videoList[0].img" /> -->
                  <video
                    controls
                    ref="mainVideo0"
                    @play="pauseOtherVideosApp(0, 'mainVideo0')"
                  >
                    <source :src="videoList0[0].videoUrl" type="video/mp4" />
                  </video>
                </div>

                <div class="content_item_title">
                  <p class="title">{{ videoList0[0].title }}</p>
                </div>
              </div>
              <div class="video_list" v-if="videoList.length">
                <div
                  class="content_item"
                  v-for="(item, index) in videoList"
                  :key="index"
                >
                  <div class="content_item_img">
                    <video
                      controls
                      :ref="'mainVideo-' + index"
                      @play="pauseOtherVideosApp(index, 'mainVideo-' + index)"
                    >
                      <source :src="item.videoUrl" type="video/mp4" />
                    </video>
                  </div>
                  <div class="content_item_title">
                    <p class="title">{{ item.title }}</p>
                  </div>
                </div>
              </div>
              <div class="content_top" v-else>
                <el-empty :description="$t('noData')"></el-empty>
              </div>
            </div></div
        ></AppcontentList>
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"

        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
    <el-dialog
      :visible.sync="dialogVisible"
      :title="currnetVideo.title"
      width="60%"
      append-to-body
      class="dialog_video"
      :before-close="handleClose"
    >
      <div class="dialog_content">
        <video
          width="100%"
          controls
          :ref="'currentVideoRef'"
          autoplay
          @play="playCurrentVideo()"
        >
          <source :src="currnetVideo.videoUrl" type="video/mp4" />
        </video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import ckplayer from '../../plugins/ckplayer.min.js';
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { videoTab } from '@/const';
import { fetchConentList } from '@/assets/api';
export default {
  name: 'News',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,

    swiper,
    swiperSlide,
  },
  data() {
    return {
      currentIndex: 0,
      page: { current: 1, size: 10, total: 20 },
      tabList: videoTab,
      cloumnId: null,
      videoDefault: require('@/assets/img/video_default.png'),
      videoList0: [],
      videoList: [
        // {
        //   title: '特邀剧目',
        //   eng: 'Specially invited plays',
        //   desc: '第十一届乌镇戏剧节特邀剧目包括【璀璨国际】【剧场英姿】【纵横天下】【新锐光芒】【舞之剧场】【学院观察】【没有不可能】七大板块。',
        //   videoUrl: 'wz_video2.mp4',
        // },
      ],
      mainSwiper: null,
      thumbSwiper: null,
      dialogVisible: false,
      currnetVideo: {},
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.cloumnId) {
      this.cloumnId = this.$route.query.cloumnId;
    }
    this.getList();
  },
  watch: {
    $route(to, from) {
      if (to.query.cloumnId !== from.query.cloumnId) {
        this.cloumnId = to.query.cloumnId;
        this.getList();
      }
    },
  },
  methods: {
    init() {
      //缩略图
      var swiper = new Swiper('#mySwiper', {
        spaceBetween: 10,
        slidesPerView: 9,
        watchSlidesProgress: true,
        loop: false, // 设置为true 则开启loop模式
        freeMode: true, // 默认为false，普通模式：slide滑动时只滑动一格
        initialSlide: 1,
        on: {
          // click: () => {
          //   // 缩略图实例
          //   let swiperThumbs = swiper;
          //   // 主图实例
          //   let swiperTop = swiper2;
          //   let activeIndex = swiperThumbs.clickedIndex;
          //   swiperTop.slideTo(activeIndex, 1000, false);
          // },
        },
        navigation: {
          nextEl: '.thumb-button-next',
          prevEl: '.thumb-button-prev',
        },
      });
      //   主图
      var swiper2 = new Swiper('#mySwiper2', {
        spaceBetween: -80,
        effect: 'coverflow',
        slidesPerView: 2,
        initialSlide: 1, // 索引从0开始，1表示第2张
        loop: false, // 设置为true 则开启loop模式
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -10, // 负值使两侧图片向内收缩
          depth: 150,
          modifier: 1.2, // 增强透视效果
          slideShadows: false,
        },
        on: {
          slideChange: () => {
            this.pauseAllVideos();
          },
        },
        //上下按钮点击轮播效果
        navigation: {
          nextEl: '.video-button-next',
          prevEl: '.video-button-prev',
        },
        thumbs: {
          swiper: swiper,
        },
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        multipleActiveThumbs: true,
      });

      // 监听主图 Swiper 的 slideChange 事件
      swiper2.on('slideChange', function () {
        const activeIndex = swiper2.realIndex;
        document
          .querySelectorAll('#mySwiper .swiper-slide')
          .forEach((slide) => {
            slide.classList.remove('active-thumb');
          });
        const thumbSlides = document.querySelectorAll(
          '#mySwiper .swiper-slide'
        );
        if (thumbSlides[activeIndex]) {
          thumbSlides[activeIndex].classList.add('active-thumb');
        }
      });

      // 初始化时设置第二个缩略图为 active
      document
        .querySelectorAll('#mySwiper .swiper-slide')[1]
        ?.classList.add('active-thumb');
    },
    getVideoUrl(filename) {
      try {
        return `${process.env.BASE_URL}img/${filename}`;
        // return require(`@/assets/img/${filename}`);
      } catch (e) {
        console.error('视频加载失败:', filename);
        return '';
      }
    },
    // 暂停所有视频
    pauseAllVideos() {
      this.videoList.forEach((_, i) => {
        const video = this.$refs[`mainVideo-${i}`]?.[0];
        if (video) video.pause();
      });
    },
    // 暂停其他视频
    pauseOtherVideos(currentIndex, ref) {
      this.videoList.forEach((_, i) => {
        if (i !== currentIndex) {
          const video = this.$refs[`mainVideo-${i}`]?.[0];
          if (video) video.pause();
        }
        // document.querySelectorAll('#mySwiper2 .play_con ').style.display =
        //   'none';
      });
    },
    // app暂停其他视频
    pauseOtherVideosApp(currentIndex, ref) {
      if (ref == 'mainVideo0') {
        //  this.videoList全部暂停
        this.videoList.forEach((_, i) => {
          const video = this.$refs[`mainVideo-${i}`]?.[0];
          if (video) video.pause();
        });
      } else {
        //  this.videoList上面的暂停
        const videoTop = this.$refs.mainVideo0;
        videoTop && videoTop.pause();

        this.videoList.forEach((_, i) => {
          if (i !== currentIndex) {
            const video = this.$refs[`mainVideo-${i}`]?.[0];
            if (video) video.pause();
          }
        });
      }
    },
    playVideo(video) {
      this.currnetVideo = video;
      this.dialogVisible = true;
    },
    playCurrentVideo() {
      const video = this.$refs.currentVideoRef;
      if (video) video.play();
    },
    handleClose() {
      const video = this.$refs.currentVideoRef;
      if (video) video.pause();
      this.dialogVisible = false;
    },
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    getList() {
      const data = {
        columnIds: this.cloumnId,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.videoList0 = [];
        if (res.records.length) {
          this.videoList = res.records.map((r) => {
            if (r.details) {
              r.videoUrl = r.details.cs;
            }
            return r;
          });
          this.videoList0.push(this.videoList[0]);
        } else {
          this.videoList = [];
        }

        this.$nextTick(() => {
          this.init();
        });
      });
    },
    toDetail(id) {
      this.$router.push({ path: `/newsDetail?id=${id}` });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 40px 0;

    .video_con {
      position: relative;
      .video-button-next,
      .video-button-prev {
        width: 47px;
        height: 59px;
        /* background-color: rgba(255, 255, 255, 0.2); */
        position: absolute;
        top: 55%;
        z-index: 99;
      }

      .video-button-next {
        right: 19.5%;
        background-image: url('../../assets/img/videoList_right.png') !important;
        background-size: 100% 100%;
        cursor: pointer;
      }

      .video-button-prev {
        left: 20%;
        background-size: 100% 100%;
        background-image: url('../../assets/img/videoList_left.png') !important;
        cursor: pointer;
        z-index: 99;
      }

      .thumb-button-next,
      .thumb-button-prev {
        width: 37px;
        height: 46px;
        /* background-color: rgba(255, 255, 255, 0.2); */
        position: absolute;
        top: 40%;
        z-index: 99;
      }

      .thumb-button-next {
        right: 0;
        background-image: url('../../assets/img/thumb_right.png') !important;
        background-size: 100% 100%;
        cursor: pointer;
      }

      .thumb-button-prev {
        left: 0;
        background-size: 100% 100%;
        background-image: url('../../assets/img/thumb_left.png') !important;
        cursor: pointer;
        z-index: 99;
      }
      .mySwiper {
        position: relative;
      }
      .mySwiper2 {
        position: relative;
        // height: 15.3333rem;
        /* 强制所有 Slide 以底部为中心缩放 */
        .video_item_default {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center; /* 图片的中心与容器的中心对齐 */
        }
        .swiper-slide {
          transform-origin: center bottom !important;
        }

        /* 两侧缩小 + 微调 */
        .swiper-slide:not(.swiper-slide-active) {
          transform: scale(0.8) translateY(0px) !important;
        }

        /* 中间保持原样 */
        .swiper-slide-active {
          transform: scale(1) translateY(0) !important;
        }
      }
      .video_slide {
        .video_item {
          width: 100%;
          height: 35.125rem;
          overflow: hidden;
          position: relative;
          margin-left: 0.5rem;

          img {
            width: 100%;
            height: auto;
            position: relative;
          }

          .video_title {
            width: 100%;
            position: absolute;
            z-index: 5;
            bottom: 0;
            left: 0;
            height: 5rem;
            line-height: 5rem;
            width: 100%;
            padding: 0 2.375rem;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.5) 100%
            ); /* 半透明背景增强效果 */
            color: #fff;
            text-align: left;
            box-sizing: border-box;
            font-size: 1.75rem;
          }
        }
      }
    }
  }
  .app_content_top {
    min-height: 57.2vh;
    .video_top {
      height: 15.25rem;
      overflow: hidden;
      position: relative;

      .content_item_title {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 3rem;
        line-height: 3rem;
        color: #fff;
        font-size: 1rem;
        padding: 0 1rem;
        box-sizing: border-box;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 1)
        );
      }
      video {
        width: 100%;
        // height: auto;
        object-fit: cover;
      }
    }
    .video_list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 0.4167rem; /* 设置间距 */
      margin-top: 1.3333rem;
      .content_item {
        width: calc((100% - 10px) / 2);
        background: #fff;
        margin-bottom: 1rem;
        height: 10.8333rem;
        .content_item_img {
          width: 100%;
          height: 7.4167rem;
          overflow: hidden;
          video {
            width: 100%;
            // height: auto;
            object-fit: cover;
          }
        }
        .content_item_title {
          flex: 1;
          padding: 1rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title {
            text-align: left;
            font-size: 1rem;
            color: #333;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 1; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  position: relative;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.swiper {
  width: 100%;
  height: 143px;
  margin-left: auto;
  margin-right: auto;
}

.mySwiper2 {
  height: 80%;
  width: 100%;
  overflow: hidden;
  .play_con {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 9999;
    transform: translate(-25px, -25px);
    img {
      width: 50px;
      height: 50px;
      opacity: 0;
    }
  }
  .swiper-slide-active {
    opacity: 1;
    img {
      width: 50px;
      height: 50px;
      opacity: 1;
    }
  }
  .swiper-slide:not(.swiper-slide-active) {
    pointer-events: none;
    opacity: 0.6;
  }
}

.mySwiper {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
  width: 100%;
  overflow: hidden;
  height: 135px;
  video {
    width: 240px;
    overflow: hidden;
  }
  .play_con {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 9999;
    transform: translate(-25px, -25px);
    img {
      width: 50px;
      height: 50px;
      opacity: 0;
    }
  }
}

#mySwiper {
  .swiper-slide {
    /* 非激活状态的缩略图样式 */
    opacity: 0.6;
    border: 6px solid #fff;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .swiper-slide.active-thumb {
    /* 设置你想要的样式，例如边框、阴影等 */
    border: 6px solid;
    border-image: linear-gradient(
        to right,
        rgba(170, 229, 239, 1),
        rgba(177, 187, 255, 1)
      )
      6 6;
    opacity: 1;
    img {
      opacity: 1;
    }
  }
}
::v-deep {
  .el-dialog__header {
    background: #dadbdf;
    font-size: 1.75rem;
    color: #424451;
    font-family: SourceHanSansCN-Medium;
    padding-top: 10px;
  }
  .el-dialog__body {
    padding: 1px;
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/article_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
